export default function About() {
  const features = [
    "Expert pharmacists & clinicians on-site",
    "Confidential, judgment-free environment",
    "Convenient Thornhill location",
    "Same-day prescriptions & refills",
    "Integrated pharmacy + addiction clinic",
    "Personalized care plans for every patient",
  ];

  return (
    <section id="about" className="py-12 sm:py-16 md:py-24 bg-background-50 w-full overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 w-full">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 sm:gap-12 lg:gap-16 items-center">
          {/* Left Content */}
          <div>
            <span className="text-primary-600 text-xs sm:text-sm font-bold uppercase tracking-widest">
              About Us
            </span>

            <h2 className="mt-3 text-2xl sm:text-3xl md:text-4xl lg:text-[2.6rem] font-bold text-foreground-950 leading-tight">
              Trusted Care for Your
              <span className="text-primary-600"> Recovery Journey</span>
            </h2>

            <p className="mt-4 sm:mt-5 text-sm sm:text-base text-foreground-600 leading-relaxed max-w-xl">
              Thornhill Drug-Mart partners with Toronto Safe Clinics and Pharmacies to deliver
              compassionate addiction treatment and full pharmacy care under one roof.
            </p>

            {/* Checkmark Features - 2 columns */}
            <div className="mt-6 sm:mt-8 grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-3">
              {features.map((item) => (
                <div key={item} className="flex items-start gap-2.5">
                  <div className="w-5 h-5 bg-primary-500 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-background-50 text-xs" />
                  </div>
                  <span className="text-sm text-foreground-700 leading-snug">{item}</span>
                </div>
              ))}
            </div>

            {/* Bottom CTA bar */}
            <div className="mt-8 sm:mt-10 flex flex-col sm:flex-row items-stretch sm:items-center gap-3 sm:gap-4">
              <a
                href="tel:9057099985"
                className="inline-flex items-center justify-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 px-6 py-3 rounded-lg text-sm font-semibold transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line" />
                (905) 709-9985
              </a>
              <a
                href="/location"
                className="inline-flex items-center justify-center gap-2 border border-foreground-300 text-foreground-700 hover:border-primary-500 hover:text-primary-600 px-6 py-3 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-map-pin-line" />
                Visit Our Location
              </a>
            </div>
          </div>

          {/* Right Image */}
          <div className="relative order-first lg:order-last">
            <div className="relative rounded-2xl overflow-hidden">
              <div className="w-full aspect-[4/3] sm:aspect-[4/3] max-h-[400px] lg:max-h-[480px]">
                <img
                  src="https://storage.readdy-site.link/project_files/0815d13c-0839-4294-85c9-62595f58b69d/d73b9c88-f1bb-4158-b6c3-ef512b1428fc_compressed_WhatsApp-Image-2026-03-31-at-2.26.06-PM-8.webp"
                  alt="Thornhill Drug-Mart Pharmacy Team at work"
                  className="w-full h-full object-cover object-center"
                  loading="lazy"
                  decoding="async"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}